import { Badge } from '@mantine/core'
import { FC } from 'react'

interface LabelProps {
  text?: string
  loading?: boolean
  className?: string
}

const Label: FC<LabelProps> = ({ text = 'Class', className = '' }) => (
  <Badge
    bg="#EAEAEA"
    c="#242424"
    className={className}
    style={{ height: '27px', padding: '4px 20px' }}
  >
    {text}
  </Badge>
)

export default Label
